import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { Box, Button, Card, Grid, Icon, Link, Progress, Text } from "~/components-shared";
import styled, { useTheme } from "styled-components";
import { Chart } from "react-chartjs-2";
import memberInsights from "~/charts/memberInsights";
import StyledIcon from "~/components/StyledIcon";
import { helpers } from "~/lib/helpers";
const InfoButton = styled(Button)`
  position: absolute;
  top: 1rem;
  right: 1rem;
`;
const TaskStatusCard = _ref => {
  let {
    dateFrom,
    dateTo,
    widget,
    ...rest
  } = _ref;
  const {
    engagedByDay,
    completedByDay,
    total
  } = widget.data;
  const theme = useTheme();
  const totalSum = total.created + total.moved + total.completed;
  const [currPeriod, prevPeriod] = helpers.humanReadablePeriodDiff(dateFrom, dateTo);
  return /*#__PURE__*/React.createElement(Card, rest, /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    fontSize: 8,
    s: {
      mb: 3
    }
  }, "Task Status"), totalSum > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    weight: "semiBold",
    fontSize: 4,
    s: {
      mb: 1
    }
  }, "Engaged"), /*#__PURE__*/React.createElement(Box, {
    style: {
      height: "80px"
    },
    s: {
      mb: 1
    }
  }, /*#__PURE__*/React.createElement(Chart, _extends({
    id: "chart-js"
  }, memberInsights.taskEngaged(theme, engagedByDay, currPeriod, prevPeriod)))), /*#__PURE__*/React.createElement(Text, {
    weight: "semiBold",
    fontSize: 4,
    s: {
      mb: 1
    }
  }, "Completed"), /*#__PURE__*/React.createElement(Box, {
    style: {
      height: "80px"
    },
    s: {
      mb: 3
    }
  }, /*#__PURE__*/React.createElement(Chart, _extends({
    id: "chart-js"
  }, memberInsights.taskCompleted(theme, completedByDay, currPeriod, prevPeriod)))), /*#__PURE__*/React.createElement(Grid, {
    cols: 3,
    template: "auto minmax(100px, 70%) 1rem",
    align: "center",
    gap: 3
  }, /*#__PURE__*/React.createElement(Link, {
    color: "text",
    fontSize: 4,
    weight: "semiBold"
  }, "Total"), /*#__PURE__*/React.createElement(Progress, {
    values: [total.created / (totalSum || 1) * 100, total.moved / (totalSum || 1) * 100, total.completed / (totalSum || 1) * 100],
    height: 2,
    labels: [`Created: ${total.created}`, `Moved: ${total.moved}`, `Closed: ${total.completed}`],
    colors: ["#85b8ff", "#a5a0e7", "#A0D7E7"]
  }), /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    fontSize: 3
  }, totalSum))) : /*#__PURE__*/React.createElement(Grid, {
    cols: 1,
    justify: "center",
    s: {
      mt: 8
    }
  }, /*#__PURE__*/React.createElement(StyledIcon, {
    src: "target",
    color: "translucentPrimary"
  }), /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    weight: "semiBold",
    display: "block",
    s: {
      mt: 6
    },
    align: "center",
    style: {
      maxWidth: "400px"
    }
  }, "No task interactions")), /*#__PURE__*/React.createElement(InfoButton, {
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": "Info",
    color: "translucentPrimary",
    display: "inline",
    fontSize: 3,
    lineHeight: 3,
    s: {
      p: 1,
      ml: 2
    },
    outline: false,
    rounded: true
  }, /*#__PURE__*/React.createElement(Icon, {
    scale: 4,
    src: "infoOutline"
  })));
};
export default TaskStatusCard;